import {Base} from "./base";

class ServeService extends Base {
  constructor() {
    super();
  }

  async detail(id) {
    const {code, obj = {}} = await this.$http('smarthos.serve.info.details', {id}, {}, {noloading: true});
    return code === '0' ? obj : {};
  }
}

export const serveService = new ServeService();



// WEBPACK FOOTER //
// ./src/services/serve.js